import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26b728bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = { class: "fb-wrapper" }
const _hoisted_3 = { class: "fb-form" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fb-form-heading" }, "How does this trailer look?", -1))
const _hoisted_5 = { class: "fb-form-paragraph directions" }
const _hoisted_6 = { class: "fb-content-wrapper" }
const _hoisted_7 = { class: "fb-form-cards" }
const _hoisted_8 = { class: "fb-inner-cards" }
const _hoisted_9 = { class: "fb-container" }
const _hoisted_10 = { class: "fb-card-label" }
const _hoisted_11 = { class: "fb-card-image" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Brakes ", -1))
const _hoisted_13 = { class: "fb-card-buttons" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-up" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "fb-container" }
const _hoisted_19 = { class: "fb-card-label" }
const _hoisted_20 = { class: "fb-card-image" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode(" Tires "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("& Wheels ")
], -1))
const _hoisted_22 = { class: "fb-card-buttons" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-up" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "fb-container" }
const _hoisted_28 = { class: "fb-card-label" }
const _hoisted_29 = { class: "fb-card-image" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Lights ", -1))
const _hoisted_31 = { class: "fb-card-buttons" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-up" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "fb-container" }
const _hoisted_37 = { class: "fb-card-label" }
const _hoisted_38 = { class: "fb-card-image" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Body Damage ", -1))
const _hoisted_40 = { class: "fb-card-buttons" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-up" }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "fb-container" }
const _hoisted_46 = { class: "fb-card-label" }
const _hoisted_47 = { class: "fb-card-image" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode(" Kingpin &"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Landing Gear ")
], -1))
const _hoisted_49 = { class: "fb-card-buttons" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-up" }, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "fb-container" }
const _hoisted_55 = { class: "fb-card-label" }
const _hoisted_56 = { class: "fb-card-image" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode(" Airlines "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("& Electrical ")
], -1))
const _hoisted_58 = { class: "fb-card-buttons" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-up" }, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = { class: "fb-container" }
const _hoisted_64 = { class: "fb-card-label" }
const _hoisted_65 = { class: "fb-card-image" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Other ", -1))
const _hoisted_67 = { class: "fb-card-buttons" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-up" }, null, -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-thumbs-down" }, null, -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { class: "fb-form-buttons d-flex flex-column align-items-center" }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fb-form-paragraph advisory" }, " By taking possession of this trailer, I certify that I have reported any damage to this trailer and/or any other concerns about this trailer. I also understand that this trailer assessment is NOT the same as the daily 24 hour pre-trip inspection that I must do on my truck and trailer, which I will complete through Geotab each day. ", -1))
const _hoisted_75 = [
  _hoisted_74
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgBrakes = _resolveComponent("SvgBrakes")!
  const _component_SvgTires = _resolveComponent("SvgTires")!
  const _component_SvgLights = _resolveComponent("SvgLights")!
  const _component_SvgDamage = _resolveComponent("SvgDamage")!
  const _component_SvgKingpinLandingGearVue = _resolveComponent("SvgKingpinLandingGearVue")!
  const _component_SvgAirlinesElectricalVue = _resolveComponent("SvgAirlinesElectricalVue")!
  const _component_SvgOtherTrailer = _resolveComponent("SvgOtherTrailer")!
  const _component_fbx_button = _resolveComponent("fbx-button")!
  const _component_DotInspectionOverdueConfirmation = _resolveComponent("DotInspectionOverdueConfirmation")!
  const _component_AcceptWithDamageConfirmation = _resolveComponent("AcceptWithDamageConfirmation")!
  const _component_ConfirmReportedDamage = _resolveComponent("ConfirmReportedDamage")!
  const _component_GoBackConfirmation = _resolveComponent("GoBackConfirmation")!
  const _component_RejectWithDamageConfirmation = _resolveComponent("RejectWithDamageConfirmation")!
  const _component_DotSubmissionConfirmation = _resolveComponent("DotSubmissionConfirmation")!
  const _component_PreviousDamageSafetyConfirmation = _resolveComponent("PreviousDamageSafetyConfirmation")!
  const _component_ConfirmPreviousReportedDamage = _resolveComponent("ConfirmPreviousReportedDamage")!
  const _component_ConfirmPreTripReportedDamage = _resolveComponent("ConfirmPreTripReportedDamage")!
  const _component_SomethingWrongOverlay = _resolveComponent("SomethingWrongOverlay")!
  const _component_DriverLoaded = _resolveComponent("DriverLoaded")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isViewLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, " Trailer: #" + _toDisplayString(_ctx.trailerNumber), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(["fb-form-card brakes-airlines", _ctx.getActiveClass(_ctx.brakes)])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_SvgBrakes, { class: "fb-svg brakes" })
                    ]),
                    _hoisted_12
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-good",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (
                                                _ctx.setTypeStatus(_ctx.brakes, false)
                                            ))
                    }, _hoisted_15),
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-bad",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (
                                                _ctx.setTypeStatus(
                                                    _ctx.brakes,
                                                    true,
                                                    'BrakeDamage'
                                                )
                                            ))
                    }, _hoisted_17)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["fb-form-card tires-wheels", _ctx.getActiveClass(_ctx.tires)])
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_SvgTires, { class: "fb-svg tires" })
                    ]),
                    _hoisted_21
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-good",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTypeStatus(_ctx.tires, false)))
                    }, _hoisted_24),
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-bad",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (
                                                _ctx.setTypeStatus(
                                                    _ctx.tires,
                                                    true,
                                                    'TireDamage'
                                                )
                                            ))
                    }, _hoisted_26)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["fb-form-card lights-electrical", _ctx.getActiveClass(_ctx.lights)])
              }, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_SvgLights, { class: "fb-svg lights" })
                    ]),
                    _hoisted_30
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-good",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (
                                                _ctx.setTypeStatus(_ctx.lights, false)
                                            ))
                    }, _hoisted_33),
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-bad",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (
                                                _ctx.setTypeStatus(
                                                    _ctx.lights,
                                                    true,
                                                    'ElectricalDamage'
                                                )
                                            ))
                    }, _hoisted_35)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["fb-form-card damage-other mr-0", _ctx.getActiveClass(_ctx.damage)])
              }, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_SvgDamage, { class: "fb-svg damage" })
                    ]),
                    _hoisted_39
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-good",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (
                                                _ctx.setTypeStatus(_ctx.damage, false)
                                            ))
                    }, _hoisted_42),
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-bad",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (
                                                _ctx.setTypeStatus(
                                                    _ctx.damage,
                                                    true,
                                                    'BodyDamage'
                                                )
                                            ))
                    }, _hoisted_44)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["fb-form-card kingpin mr-0", _ctx.getActiveClass(_ctx.kingpinLanding)])
              }, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_SvgKingpinLandingGearVue, { class: "fb-svg kingpin" })
                    ]),
                    _hoisted_48
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-good",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (
                                                _ctx.setTypeStatus(
                                                    _ctx.kingpinLanding,
                                                    false
                                                )
                                            ))
                    }, _hoisted_51),
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-bad",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (
                                                _ctx.setTypeStatus(
                                                    _ctx.kingpinLanding,
                                                    true,
                                                    'KingpinDamage'
                                                )
                                            ))
                    }, _hoisted_53)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["fb-form-card airlines mr-0", _ctx.getActiveClass(_ctx.airlinesElectrical)])
              }, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_component_SvgAirlinesElectricalVue, { class: "fb-svg airlines" })
                    ]),
                    _hoisted_57
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-good",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (
                                                _ctx.setTypeStatus(
                                                    _ctx.airlinesElectrical,
                                                    false
                                                )
                                            ))
                    }, _hoisted_60),
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-bad",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (
                                                _ctx.setTypeStatus(
                                                    _ctx.airlinesElectrical,
                                                    true,
                                                    'AirlinesElectricalDamage'
                                                )
                                            ))
                    }, _hoisted_62)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["fb-form-card other mr-0", _ctx.getActiveClass(_ctx.other)])
              }, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createVNode(_component_SvgOtherTrailer, { class: "fb-svg other" })
                    ]),
                    _hoisted_66
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-good",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setTypeStatus(_ctx.other, false)))
                    }, _hoisted_69),
                    _createElementVNode("button", {
                      class: "btn btn-link fb-btn-bad",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (
                                                _ctx.setTypeStatus(
                                                    _ctx.other,
                                                    true,
                                                    'OtherAssessment'
                                                )
                                            ))
                    }, _hoisted_71)
                  ])
                ])
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            (_ctx.isVirtualRedTagFlow)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_fbx_button, {
                    "button-text": 
                                    _ctx.showButtonLoadingRedTag
                                        ? 'Tagging'
                                        : 'Confirm Virtual Red Tag'
                                ,
                    class: _normalizeClass(_ctx.virtualRedTagClass),
                    "show-loading": _ctx.showButtonLoadingRedTag,
                    disabled: 
                                    !_ctx.canConfirmVirtualRedTag ||
                                    _ctx.showButtonLoadingRedTag
                                ,
                    onClick: _ctx.showDotSafeConfirmation
                  }, null, 8, ["button-text", "class", "show-loading", "disabled", "onClick"]),
                  _createVNode(_component_fbx_button, {
                    "button-text": "Cancel",
                    theme: "primaryOutline",
                    class: "btn btn-outline-primary italics",
                    onClick: _ctx.cancelVirtualRedTag
                  }, null, 8, ["onClick"])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_fbx_button, {
                    "button-text": _ctx.submitButtonText,
                    class: _normalizeClass(_ctx.possessionClass),
                    "show-loading": _ctx.showButtonLoadingTake,
                    disabled: _ctx.showButtonLoadingTake,
                    onClick: _ctx.checkPreviousDamage
                  }, null, 8, ["button-text", "class", "show-loading", "disabled", "onClick"]),
                  (_ctx.isAttach)
                    ? (_openBlock(), _createBlock(_component_fbx_button, {
                        key: 0,
                        "button-text": 
                                    _ctx.showButtonLoadingRedTag
                                        ? 'Tagging'
                                        : 'Virtual Red Tag'
                                ,
                        theme: "primaryOutline",
                        class: _normalizeClass(_ctx.withDamageClass),
                        "show-loading": _ctx.showButtonLoadingRedTag,
                        disabled: _ctx.showButtonLoadingRedTag,
                        onClick: _ctx.showDotSafeConfirmation
                      }, null, 8, ["button-text", "class", "show-loading", "disabled", "onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.isAttach)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_75))
                    : _createCommentVNode("", true)
                ], 64)),
            (!_ctx.isVirtualRedTagFlow)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: "btn btn-link fb-btn-not-ready",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onNavigateBack && _ctx.onNavigateBack(...args)))
                }, " Go Back "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_ctx.showDotExpiredModal)
      ? (_openBlock(), _createBlock(_component_DotInspectionOverdueConfirmation, {
          key: 1,
          association: _ctx.association,
          company: _ctx.company,
          trailerNumber: _ctx.trailerNumber,
          onAccepted: _ctx.acceptDotExpired
        }, null, 8, ["association", "company", "trailerNumber", "onAccepted"]))
      : _createCommentVNode("", true),
    _createVNode(_component_AcceptWithDamageConfirmation, {
      association: _ctx.association,
      skipDotPrompt: _ctx.skipReportedDamageDotPrompt,
      isDotSafe: _ctx.isDotSafe
    }, null, 8, ["association", "skipDotPrompt", "isDotSafe"]),
    _createVNode(_component_ConfirmReportedDamage, { association: _ctx.association }, null, 8, ["association"]),
    _createVNode(_component_GoBackConfirmation, { association: _ctx.association }, null, 8, ["association"]),
    _createVNode(_component_RejectWithDamageConfirmation, { association: _ctx.association }, null, 8, ["association"]),
    _createVNode(_component_DotSubmissionConfirmation, {
      dotInspectionExpired: _ctx.isAssessmentTrailerDotExpired,
      showConfirmation: _ctx.showDotConfirmation,
      submitting: _ctx.showButtonLoadingRedTag,
      titleText: _ctx.dotSafeConfirmationTitle,
      onAccepted: _ctx.onRedTag
    }, null, 8, ["dotInspectionExpired", "showConfirmation", "submitting", "titleText", "onAccepted"]),
    _createVNode(_component_DotSubmissionConfirmation, {
      dotInspectionExpired: _ctx.isAssessmentTrailerDotExpired,
      showConfirmation: _ctx.showDotConfirmationForExpiredDot,
      submitting: _ctx.showButtonLoadingRedTag,
      onAccepted: _ctx.onAcceptTrailer
    }, null, 8, ["dotInspectionExpired", "showConfirmation", "submitting", "onAccepted"]),
    _createVNode(_component_PreviousDamageSafetyConfirmation, {
      showConfirmation: _ctx.showPreviousDamageConfirmation,
      association: _ctx.association,
      onAccepted: _ctx.hidePreviousDamageConfirmation,
      trailerAssessmentResult: _ctx.lastActiveTrailerAssessmentResult
    }, null, 8, ["showConfirmation", "association", "onAccepted", "trailerAssessmentResult"]),
    _createVNode(_component_ConfirmPreviousReportedDamage, {
      shouldHide: _ctx.showDotExpiredModal,
      trailerAssessmentResult: _ctx.lastActiveTrailerAssessmentResult,
      onPreviousDamage: _ctx.confirmPreviousDamagePresent
    }, null, 8, ["shouldHide", "trailerAssessmentResult", "onPreviousDamage"]),
    _createVNode(_component_ConfirmPreTripReportedDamage, { trailerAssessmentResult: _ctx.lastActiveTrailerAssessmentResult }, null, 8, ["trailerAssessmentResult"]),
    (_ctx.hasError)
      ? (_openBlock(), _createBlock(_component_SomethingWrongOverlay, {
          key: 2,
          message: _ctx.error?.message,
          customBackFunc: _ctx.goBackToBeginningOfAssessment
        }, null, 8, ["message", "customBackFunc"]))
      : _createCommentVNode("", true),
    (_ctx.showLoadedTrailerModal)
      ? (_openBlock(), _createBlock(_component_DriverLoaded, {
          key: 3,
          attachedTrailerNumber: _ctx.currentAttachedTrailerNumber,
          attachedTrailerCompany: _ctx.currentAttachedTrailerCompany,
          showDeepLinkButton: true,
          association: _ctx.isAttach == true ? 'attach' : 'detach'
        }, null, 8, ["attachedTrailerNumber", "attachedTrailerCompany", "association"]))
      : _createCommentVNode("", true)
  ]))
}